/**
 * size-select-cue.js
 * No size looks pre-selected until the shopper picks one, on the product page AND in the
 * collection "Quick buy" modal. Add to cart / Buy it now / sticky-bar ATC without a size
 * => shake the size pills + show an error message.
 *
 * State is an attribute `data-size-unset` on a scope element:
 *   - product page: <html>  (set by an inline snippet in main-product.liquid before first paint)
 *   - quick buy:    the <quick-add-modal> element (set here when the modal opens)
 */
(function () {
  "use strict";
  var root = document.documentElement;
  var MSG = "Please select a size";

  function scopeOf(el) { return (el && el.closest && el.closest("quick-add-modal")) || root; }
  function isUnset(scope) { return scope.hasAttribute("data-size-unset"); }
  function wrapperIn(scope) { return scope.querySelector(".main-product_info .option-name-size .varient-model-wrapper"); }

  function messageEl(scope) {
    var w = wrapperIn(scope);
    if (!w) return null;
    var el = w.parentElement.querySelector(".size-select-error");
    if (!el) {
      el = document.createElement("p");
      el.className = "size-select-error";
      el.setAttribute("role", "alert");
      el.textContent = MSG;
      w.insertAdjacentElement("afterend", el);
    }
    return el;
  }
  function clearError(scope) {
    var w = wrapperIn(scope);
    if (w) w.classList.remove("size-shake");
    var m = scope.querySelector(".size-select-error");
    if (m) m.classList.remove("is-visible");
  }
  function showError(scope) {
    var w = wrapperIn(scope);
    if (!w) return;
    var m = messageEl(scope);
    if (m) m.classList.add("is-visible");
    w.classList.remove("size-shake");
    void w.offsetWidth; // restart animation
    w.classList.add("size-shake");
    var rect = w.getBoundingClientRect();
    if (rect.top < 80 || rect.bottom > window.innerHeight - 80) w.scrollIntoView({ behavior: "smooth", block: "center" });
    if (navigator.vibrate) { try { navigator.vibrate(60); } catch (e) {} }
  }
  function markSelected(scope) {
    if (!isUnset(scope)) return;
    scope.removeAttribute("data-size-unset");
    clearError(scope);
  }

  // ---- quick buy modal: start every open with no size chosen -------------------------------
  function initModal(modal) {
    if (!modal || !modal.hasAttribute("open")) return;
    var pills = modal.querySelectorAll(".main-product_info .option-name-size .varient-class label.variants_btn");
    if (pills.length > 1) { modal.setAttribute("data-size-unset", ""); clearError(modal); }
    else modal.removeAttribute("data-size-unset");
  }
  if ("MutationObserver" in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var t = m.target;
        if (m.type === "attributes" && t.tagName === "QUICK-ADD-MODAL" && t.hasAttribute("open")) initModal(t);
        if (m.type === "childList") {
          // content of an already-open modal was (re)filled
          var modal = m.target.closest && m.target.closest("quick-add-modal[open]");
          if (modal && !modal.hasAttribute("data-size-checked")) {
            if (modal.querySelector(".main-product_info .option-name-size")) { modal.setAttribute("data-size-checked", ""); initModal(modal); }
          }
        }
        if (m.type === "attributes" && t.tagName === "QUICK-ADD-MODAL" && !t.hasAttribute("open")) {
          t.removeAttribute("data-size-checked"); t.removeAttribute("data-size-unset");
        }
      });
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ["open"], childList: true });
  }

  // Picking any size (including the already-checked one) clears the cue.
  document.addEventListener("click", function (e) {
    var label = e.target.closest && e.target.closest(".option-name-size .variants_btn");
    if (label && !label.classList.contains("unavailable")) markSelected(scopeOf(label));
  }, true);
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('.option-name-size input[type="radio"]')) markSelected(scopeOf(t));
  }, true);

  // Block add-to-cart forms while no size has been chosen.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var scope = scopeOf(form);
    if (!isUnset(scope)) return;
    var fid = form.getAttribute("id") || "";
    if (fid.indexOf("installment") > -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showError(scope);
  }, true);

  // Dynamic checkout (Buy it now) is rendered by Shopify and submits on its own.
  function guardClick(e) {
    var hit = e.target.closest && e.target.closest(".shopify-payment-button, .product-form__buttons shopify-buy-it-now-button");
    if (!hit) return;
    var scope = scopeOf(hit);
    if (!isUnset(scope)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showError(scope);
  }
  document.addEventListener("click", guardClick, true);
  document.addEventListener("touchend", guardClick, true);
})();
